import type { TeamRosterPerson } from '@ordo/ui/team-roster'
import type { QueryResult } from 'utils/api'

import { useApiQuery } from '../useApiQuery'

/**
 * The shared HQ staff roster with each person's Boombox (`comms`) role, for
 * Admin → Team. Archived people are included so the page's Active / Archived
 * filter is local. Read-only: HQ is where access is edited.
 */
export function useTeamRoster(): QueryResult<{ members: TeamRosterPerson[] }> {
  return useApiQuery<{ members: TeamRosterPerson[] }>('/api/team-roster?includeInactive=true')
}
